import { c as _c } from "react/compiler-runtime";
import { BackToTop } from "@/layout/BackToTop";
import { Footer } from "@/layout/Footer";
import { Header } from "@/layout/Header";
import { Navigation } from "@/layout/Navigation";
import { ROUTES } from "@/utils/constants";
import { cn } from "@/utils/helpers";
import { useRouter } from "next/router";
import { ReactNode, useState } from "react";
interface RootLayoutProps {
  children: ReactNode;
}
const ROUTES_WITHOUT_NAV: string[] = [ROUTES.NOT_FOUND, ROUTES.SECRET, ROUTES.OFFLINE];
export const RootLayout = t0 => {
  const $ = _c(21);
  const {
    children
  } = t0;
  const router = useRouter();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  let t1;
  if ($[0] !== router.pathname) {
    t1 = ROUTES_WITHOUT_NAV.includes(router.pathname);
    $[0] = router.pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowElement = !t1;
  let t2;
  if ($[2] !== isDrawerOpen || $[3] !== shouldShowElement) {
    t2 = shouldShowElement && <Navigation isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />;
    $[2] = isDrawerOpen;
    $[3] = shouldShowElement;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isDrawerOpen || $[6] !== shouldShowElement) {
    t3 = <Header isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} shouldShowDrawerToggle={shouldShowElement} />;
    $[5] = isDrawerOpen;
    $[6] = shouldShowElement;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isDrawerOpen && "blur-sm pointer-events-none";
  let t5;
  if ($[8] !== t4) {
    t5 = cn("min-h-dvh flex flex-col transition-[filter] duration-300 max-w-7xl mx-auto", t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children) {
    t6 = <main className="container-full">{children}</main>;
    $[10] = children;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Footer />;
    t8 = <BackToTop />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t6) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t9) {
    t10 = <>{t2}{t3}{t9}</>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};